import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../../session/useFetchWithAuth'

const API_URL = import.meta.env.VITE_EPC_API_URL ?? ''

export interface AdminCity {
  id: string
  name: string
}

export const useAdminCities = () => {
  const fetchWithAuth = useFetchWithAuth()

  const getCities: QueryFunction<AdminCity[]> = async () => {
    try {
      const responseData = await fetchWithAuth(`${API_URL}/admin/cities`, {
        method: 'GET',
      })
      return responseData
    } catch (error) {
      console.error('Error fetching admin cities:', error)
      throw error
    }
  }

  return useQuery({
    queryKey: ['adminCities'] as const,
    queryFn: getCities,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

export const useAdminCity = (name?: string) => {
  const fetchWithAuth = useFetchWithAuth()

  const getCity: QueryFunction<AdminCity> = async () => {
    if (!name) {
      throw new Error('City name is required')
    }

    try {
      const responseData = await fetchWithAuth(
        `${API_URL}/admin/cities/${name}`,
        {
          method: 'GET',
        }
      )
      return responseData
    } catch (error) {
      console.error('Error fetching admin city:', error)
      throw error
    }
  }

  return useQuery({
    queryKey: ['adminCity', name] as const,
    queryFn: getCity,
    retry: false,
    staleTime: 5 * 60 * 1000,
    enabled: !!name && name.length > 0,
  })
}
